import React from 'react'
import { ABHICASH_LIKE, CHECK_COMPANY_TENANT, Company_DATA } from '../../../../layouts/MainTenantconfig'
const Bank = ({ userDetailHandler, rfdByNbfc, pageNumber, selectAll, paginationHandler, admin, changehandler, allUserDetail, paymentAndVerificationHandler, paymentData, ApplicationId, loanIdData, nbfcList, selectednbfcFilter, handleNBfc, selectAllBtn, downloadReport, tenant,approvedLeadStats }) => {

    return (

        <div className="container-fluid">
            <div className="row form-group">
                <div className="col-xs-12">
                    <h3 className="text-center blue-text">Approved Leads</h3>
                </div>
            </div>
            <div className="row form-group">
                <div className="col-xs-12 col-sm-3">
                    <label>NBFC</label>
                    <select className='form-control' value={selectednbfcFilter} onChange={(e) => handleNBfc(e)}>
                        <option value=''>Select value</option>
                        {
                            nbfcList && nbfcList?.length > 0 ?
                                nbfcList?.map((value, index) => {
                                    if(value?.nbfcId == "emTYxWtA") return null;
                                    return (
                                        <option value={value?.nbfcId}>{value?.name}</option>
                                    )
                                })
                                : ''}

                    </select>
                </div>
                <div className="col-xs-12 col-sm-5 text-center">
                    {/* <div className="" style={{ display: 'inline-flex' }}>
                        <div className="" >
                            <button className='profile-save-btn' onClick={() => paymentAndVerificationHandler('verify')}>Verify Payment</button>
                        </div>
                        &nbsp;
                        <div className="col-xs-12 col-sm-3">
                            <button className='payment-btn' onClick={() => paymentAndVerificationHandler('payment')} >Make Payment</button>

                        </div>
                    </div> */}
                </div>
                <div className="col-xs-12 col-sm-4">
                    <div className='count-div'>
                        <div className='row'>
                            <div className='col-sm-4 col-xs-6'>
                                {approvedLeadStats != null  ?
                                    <button className="btn-count-new" ><div style={{ fontSize: '11px', color: '#0e5768', fontWeight: '700' }}>TOTAL APPROVED <br />AMOUNT<br /><br/></div><span style={{ color: '#2B78FF', fontSize: '20px', fontWeight: 700 }}>₹ {approvedLeadStats?.totalApprovedAmount}</span>&nbsp;</button>
                                    : ""}
                            </div>
                            <div className='col-sm-4 col-xs-6'>
                                {approvedLeadStats != null ?
                                    <button className="btn-count-new" ><div style={{ fontSize: '11px', color: '#0e5768', fontWeight: '700' }}>FRESH APPROVED <br />AMOUNT<br /><br/></div><span style={{ color: '#2B78FF', fontSize: '20px', fontWeight: 700 }}>₹ {approvedLeadStats?.FreshApprovedAmount}</span>&nbsp;</button>
                                    : ""}
                            </div>
                            <div className='col-sm-4 col-xs-6'>
                                {approvedLeadStats != null  ?
                                    <button className="btn-count-new" ><div style={{ fontSize: '11px', color: '#0e5768', fontWeight: '700' }}>REPEAT APPROVED <br />AMOUNT<br /><br/></div> <span style={{ color: '#2B78FF', fontSize: '20px', fontWeight: 700 }}>₹ {approvedLeadStats.RepeatApprovedAmount}</span>&nbsp;</button>
                                    : ""}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {
                selectednbfcFilter !== "" ?
                    <>
                        <div className='row '>
                            <div className='col-sm-2' style={{ marginTop: '20px' }}>
                                <label style={{ fontSize: '18px' }}>Select All </label>&nbsp;&nbsp;
                                <input type='checkbox' checked={selectAllBtn} onChange={(e) => selectAll(e)} />
                            </div>
                            <div className='col-sm-8'>
                                {/* <label style={{ fontSize: '18px' }}>Select All </label>&nbsp;&nbsp;
                    <input type='checkbox' onChange={(e) => selectAll(e)} /> */}
                            </div>
                            <div className='col-sm-2 text-right' style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                                <button className='profile-save-btn' onClick={() => downloadReport()}> <i className='fa fa-download'></i>&nbsp; Download</button>
                                <button className='profile-save-btn' onClick={() => rfdByNbfc()}>RFD by NBFC</button>
                            </div>
                        </div>
                        <div className='row'>

                            <div className='col-sm-12 col-xs-12'>
                                <div>
                                    <div className="overflow-x-auto">

                                        <table className="phocket-table">
                                            <thead>
                                                {
                                                    CHECK_COMPANY_TENANT(ABHICASH_LIKE) ?
                                                        <tr>
                                                            {/* <th>S.No</th> */}
                                                            <th>View Details</th>
                                                            <th>Application id</th>
                                                            <th>Loan Id</th>
                                                            <th>Name</th>
                                                            <th>Mobile Number</th>
                                                            <th>Email Id</th>
                                                            <th>Aadhar Number</th>
                                                            <th>Approved Date</th>
                                                            <th>Loan Amt</th>
                                                            <th>Pro. Fee</th>
                                                            <th>Net Payment</th>
                                                            <th>A/c No.</th>
                                                            <th>IFSC Code</th>
                                                            <th>Bank Name</th>
                                                            <th>State</th>
                                                            <th>Tenure</th>
                                                            {/* <th>Status</th> */}


                                                            <th>Select</th>
                                                            {/* {paymentData !== '' ?
                                            <th>Payment Status</th>
                                            : ""} */}
                                                        </tr>
                                                        :
                                                        <tr>
                                                            <th>View Details</th>
                                                            <th>EMI Type</th>
                                                            <th>Loan Id</th>
                                                            <th>application id</th>
                                                            <th>Name</th>
                                                            <th>Email Id</th>
                                                            <th>Mobile Number</th>
                                                            <th>Aadhar Number</th>
                                                            <th>Approved Date</th>
                                                            <th>Loan Amt</th>
                                                            <th>Pro. Fee</th>
                                                            <th>Net Payment</th>
                                                            <th>Bank Name</th>
                                                            <th>A/c No.</th>
                                                            <th>IFSC Code</th>
                                                            <th>State</th>
                                                            <th>Select</th>
                                                            {/* {paymentData !== '' ?
                                            <th>Payment Status</th>
                                            : ""} */}
                                                        </tr>
                                                }
                                            </thead>
                                            <tbody>
                                                {allUserDetail ? allUserDetail.map((data, i) => {
                                                    return (
                                                        <>
                                                            {
                                                                CHECK_COMPANY_TENANT(ABHICASH_LIKE) ?
                                                                    <tr key={i}>
                                                                        {/* <td>{i + 1}</td> */}
                                                                        <td><i className='fa fa-info' style={{ cursor: 'pointer' }} onClick={() => userDetailHandler(data)}></i></td>
                                                                        <td>{data.applicationId}</td>
                                                                        <td>{data.applicationLoanId}</td>
                                                                        <td style={{ whiteSpace: 'break-spaces' }}>{data.userName}</td>
                                                                        <td>{data.mobileNumber}</td>
                                                                        <td>{data.emailId}</td>
                                                                        <td>{data.aadharNumber}</td>
                                                                        <td>{data.approveDate}</td>
                                                                        <td>{data.loanAmount}</td>
                                                                        <td>{data.processingFee}</td>
                                                                        <td>{data.netdisbursmentAmount}</td>
                                                                        <td>{data.accountNo}</td>
                                                                        <td>{data.ifscCode}</td>
                                                                        <td>{data.bankName}</td>
                                                                        <td>{data.state}</td>
                                                                        <td>{data.loanEmi}</td>
                                                                        {/* <td>{data?.status || ""}</td> */}
                                                                        <td><input id={'disburseIcici' + i} type='checkbox' onChange={(e) => changehandler(e, data)} /></td>
                                                                    </tr>
                                                                    :
                                                                    <tr key={i}>
                                                                        <td><i className='fa fa-info' style={{ cursor: 'pointer' }} onClick={() => userDetailHandler(data)}></i></td>
                                                                        <td>{data.loanEmi}</td>
                                                                        <td>{data.applicationLoanId}</td>
                                                                        <td>{data.applicationId}</td>
                                                                        <td style={{ whiteSpace: 'break-spaces' }}>{data.userName}</td>
                                                                        <td>{data.emailId}</td>
                                                                        <td>{data.mobileNumber}</td>
                                                                        <td>{data.aadharNumber}</td>
                                                                        <td>{data.approveDate}</td>
                                                                        <td>{data.loanAmount}</td>
                                                                        <td>{data.processingFee}</td>
                                                                        <td>{data.netdisbursmentAmount}</td>
                                                                        <td>{data.bankName}</td>
                                                                        <td>{data.accountNo}</td>
                                                                        <td>{data.ifscCode}</td>
                                                                        <td>{data.state}</td>
                                                                        <td><input id={'disburseIcici' + i} type='checkbox' onChange={(e) => changehandler(e, data)} /></td>
                                                                        {/* {paymentData !== '' ? Object.keys(paymentData).includes(data.loanId) ?
                                                    // console.log((paymentData[data.loanId]))
                                                    <td>{(paymentData[data.loanId]) !== null && (paymentData[data.loanId]) !== undefined ? Object.values(paymentData[data.loanId]) : "null"}</td>
                                                    : "" : ""} */}
                                                                        {/* {Object.keys(ids).includes(data.loanId) ?
                                                    <td>{Object.values(ids[data.loanId])}</td>
                                                    : ""} */}
                                                                        {/* <td></td> */}
                                                                    </tr>
                                                            }
                                                        </>
                                                    )
                                                }) : ""}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-4 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-left btn-lg btn-block mage" id="backword" onClick={e => paginationHandler('left')}><span className="fa fa-chevron-left" /></button></div>
                                <div className="col-sm-4 col-xs-12  phoc text-center" >On this Page:<b>{allUserDetail.length}</b>&nbsp;&nbsp; PageNumber: <b>{pageNumber}</b></div>
                                <div className="col-sm-4 col-xs-12 no-padding"> <button type="button" className="btn btn-default fa fa-chevron-right btn-lg btn-block mage" id="forword" onClick={e => paginationHandler('right')}><span className="fa fa-chevron-right" /></button></div> </div>
                        </div>
                    </>
                    : ""}
        </div>
    )
}
export default Bank